import { tsInitVue } from '../js-utils'
import EventReimbursementGrid from '../vue-components/event-reimbursement-grid.vue'
import type { SubSpecialisation } from '../vue-components/ospe/sub-specialisation'
import OspeSubSpecialisationsManager from '../vue-components/ospe/sub-specialisations-manager.vue'
import { initializeOspePlaceForm } from './ospe-place-form'

const parseSubSpecialisations = (value: string): SubSpecialisation[] => {
  try {
    return JSON.parse(value) as SubSpecialisation[]
  } catch {
    return []
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const subSpecialisationsManagerEl = document.querySelector('[data-is="OspeSubSpecialisationsManager"]')
  if (subSpecialisationsManagerEl instanceof HTMLElement) {
    const dataField = document.getElementById(subSpecialisationsManagerEl.dataset.dataFieldId || '')
    if (dataField instanceof HTMLInputElement) {
      const initialValue = parseSubSpecialisations(dataField.value)
      dataField.value = JSON.stringify(initialValue)
      tsInitVue(OspeSubSpecialisationsManager, subSpecialisationsManagerEl, {
        initialValue,
        onChange: (...args: unknown[]) => {
          dataField.value = JSON.stringify(args[0] as SubSpecialisation[])
        },
      })
    }
  }

  initializeOspePlaceForm()

  if (document.querySelector('body.ospe-application.ospe-reimbursement-submissions')) {
    const eventReimbursementGridEl = document.querySelector('div[data-is="EventReimbursementGrid"]')
    if (eventReimbursementGridEl instanceof HTMLElement) {
      window.activityReimbursementGrid = tsInitVue(EventReimbursementGrid, eventReimbursementGridEl, {
        listUrl: eventReimbursementGridEl.dataset.listUrl
      })
    }
  }
})
